export default "__VITE_ASSET__BWIb0wyK__"